import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  id: "download-menu-dropdown-container",
  class: "download-menu"
}
const _hoisted_2 = { class: "download-menu__field" }
const _hoisted_3 = {
  id: "download-menu-dropdown-content",
  class: "download-menu__dropdown"
}
const _hoisted_4 = ["onClick"]

import { i18n } from '@/i18n';
import { nextTick, onMounted, onUnmounted, ref, watch } from 'vue';
import SvgLoader from '@/utils/SvgLoader.vue';
import { DownloadMenuItems, DOWNLOAD_MENU_ITEMS } from '../constants';

const OPTION_HEIGHT = 40;


export default /*@__PURE__*/_defineComponent({
  __name: 'DownloadMenuDropdown',
  props: {
    isOpenProp: { type: Boolean }
  },
  emits: ["click:selectInput", "selectedItem", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const t = i18n.t;

const isOpen = ref(false);

const emit = __emit;

watch(
  () => props.isOpenProp,
  () => {
    isOpen.value = props.isOpenProp || false;
  }
);

watch(isOpen, async (newVal) => {
  if (newVal) {
    emit('click:selectInput');
    calculateDropdownPosition();
  }
});

/**
 * メニュー項目の表示テキストを取得します。
 * @param item - メニュー項目
 */
const getDisplayText = (item: DownloadMenuItems): string => {
  switch (item) {
    case 'ForecastForReceiptFormat':
      return t('受領用内示フォーマット');
    case 'SalesResultAndCustomerForecast':
      return t('販売実績 & 客先内示');
    default:
      return '';
  }
};

/**
 * ドロップダウンの表示状態を切り替えます。
 */
const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};

/**
 * オプションを選択し、親コンポーネントに選択値を通知します。
 * @param item - 選択したアイテム
 */
const selectOption = (item: DownloadMenuItems) => {
  emit('selectedItem', item);
  isOpen.value = false;
  emit('close');
};

/**
 * ドロップダウンを閉じます。
 * @param event - クリックイベント
 */
const closeDropdown = (event: MouseEvent) => {
  if (!isOpen.value) return;
  const target = event.target;
  const selector = '#download-menu-dropdown-container';
  const arrowSelector = '#download-menu-dropdown-arrow';
  const searchSelector = '#download-menu-dropdown-content';
  if (!(target instanceof Element)) return;
  if (target.closest(arrowSelector)) return;
  if (target.closest(selector)) return;
  if (target.closest(searchSelector)) return;

  isOpen.value = false;
  emit('close');
};

onMounted(() => {
  document.addEventListener('click', closeDropdown);
});

onUnmounted(() => {
  document.removeEventListener('click', closeDropdown);
});

/**
 * ドロップダウンの位置を計算し、設定します。
 */
const calculateDropdownPosition = () => {
  nextTick(() => {
    const selectBox = document.querySelector('#download-menu-dropdown-container') as HTMLElement;
    if (selectBox) {
      const rect = selectBox.getBoundingClientRect();
      const dropdown = document.querySelector('#download-menu-dropdown-content') as HTMLElement;
      if (dropdown) {
        dropdown.style.left = `${rect.left}px`;
        dropdown.style.top = `${rect.bottom}px`;

        // ドロップダウンの高さを計算
        const desiredHeight = OPTION_HEIGHT * DOWNLOAD_MENU_ITEMS.length;

        // max-heightを計算して設定
        const availableHeight = window.innerHeight - rect.bottom - 10; // 10pxは少しのマージン
        dropdown.style.maxHeight = `${Math.min(desiredHeight, availableHeight)}px`;
      }
    }
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "download-menu_container",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (closeDropdown($event)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "download-menu__selected",
        onClick: toggleDropdown
      }, [
        _createVNode(SvgLoader, {
          id: "download-menu-dropdown-arrow",
          name: "download",
          class: "download-menu__icon"
        }),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('ダウンロード')), 1),
        (isOpen.value)
          ? (_openBlock(), _createBlock(SvgLoader, {
              key: 0,
              name: "arrowUpWhite",
              class: "download-menu__arrow"
            }))
          : (_openBlock(), _createBlock(SvgLoader, {
              key: 1,
              name: "arrowDownWhite",
              class: "download-menu__arrow"
            }))
      ]),
      (isOpen.value)
        ? (_openBlock(), _createBlock(_Teleport, {
            key: 0,
            to: "body"
          }, [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(DOWNLOAD_MENU_ITEMS), (option) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: option,
                  class: "download-menu__option",
                  onClick: ($event: any) => (selectOption(option))
                }, _toDisplayString(getDisplayText(option)), 9, _hoisted_4))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})